import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutLogosWithoutTitle = {
  factory: EElement({
    id: '96b1eda8-aa4d-a595-5cd2-597ea5493a16',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('2af073cc-a55c-1408-9844-6ad41ba30592')]),
      children: EList([
        EElement({
          id: '96b1eda8-aa4d-a595-5cd2-597ea5493a17',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: 'eb7fc2ed-4288-daf5-6c24-2c8cc397b94d',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('c2899612-db53-45ce-20da-2bdedf9e87f7'),
                  ]),
                  children: EList([
                    EElement({
                      id: '809a6db7-8c83-893c-c5e0-ee16c65d2054',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.ariseHealthLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('AriseHealth logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627306c29b4f2f95def9de58"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'c947730a-0a9e-008c-dd3d-c63747e00f8e',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.oeLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('OE logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627306c29b4f2f95def9de67"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'a0cd88cc-a2f5-a85a-1bec-2e8fdaffcc2a',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.twentyLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('2020INC logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627306c29b4f2f95def9de63"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'ab110484-96a3-6ce4-e61c-23811801a775',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.thePaakLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('The Paak logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627306c29b4f2f95def9de56"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: '1164f3dd-430b-a55d-e051-6a1d288ecf42',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.ephicientLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('Ephicient logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627306c29b4f2f95def9de62"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                    EElement({
                      id: 'fda7ca4e-873b-2a8d-03f2-deb5eb9b3e98',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Image')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          src: EText(images.toogetherLogo),
                          loading: EEnum('lazy'),
                          width: EText('auto'),
                          height: EText('auto'),
                          alt: EText('Toogether logo'),
                        }),
                        img: ELiteral({
                          name: qualify(
                            Plugins.name('Asset'),
                            typeName('Image')
                          ),
                          value: JSON.parse(
                            '{"id":"627306c29b4f2f95def9de5c"}'
                          ),
                        }),
                        styleBlockIds: EList([
                          EText('eecbb14e-1c6a-d91c-85dd-f59dfa2f760b'),
                        ]),
                        temp: ERecord({
                          img: ERecord({
                            src: EText(''),
                          }),
                        }),
                        srcsetDisabled: EBoolean(false),
                        sizes: EList([]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '2af073cc-a55c-1408-9844-6ad41ba30592',
      type: 'class',
      name: 'Logos Without Title',
      comb: '',
      styleLess:
        'position: relative; padding-top: 60px; padding-right: 30px; padding-bottom: 60px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'c2899612-db53-45ce-20da-2bdedf9e87f7',
      type: 'class',
      name: 'Clients Wrapper Three',
      comb: '',
      styleLess:
        'display: flex; margin-bottom: -10px; justify-content: space-around; flex-wrap: wrap; align-items: center;',
      children: [],
      variants: {
        small: {styleLess: 'margin-bottom: -30px;'},
        tiny: {
          styleLess:
            'display: grid; margin-bottom: 0px; justify-items: center; grid-auto-columns: 1fr; grid-column-gap: 20px; grid-row-gap: 30px; grid-template-columns: 1fr 1fr; grid-template-rows: auto auto;',
        },
      },
    },
    {
      _id: 'eecbb14e-1c6a-d91c-85dd-f59dfa2f760b',
      type: 'class',
      name: 'Clients Image Three',
      comb: '',
      styleLess: 'margin-right: 15px; margin-bottom: 10px; margin-left: 15px;',
      children: [],
      variants: {
        small: {
          styleLess:
            'margin-right: 20px; margin-bottom: 30px; margin-left: 20px;',
        },
        tiny: {
          styleLess: 'margin-right: 0px; margin-bottom: 0px; margin-left: 0px;',
        },
        medium: {styleLess: 'margin-bottom: 30px;'},
      },
    },
  ],
} as const;
